import { useRef, useState } from "react";

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;

export const useVoiceInput = (onResult) => {
  const recognitionRef = useRef(null);
  const [isListening, setIsListening] = useState(false);

  const startListening = () => {
    if (!SpeechRecognition) {
      alert("Voice recognition not supported in this browser");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-IN"; // Hindi + English mix
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => {
      setIsListening(true); //  start indicator
    };

    recognition.onresult = (event) => {
      const speechText = event.results[0][0].transcript;
      onResult(speechText);
    };

    recognition.onerror = (err) => {
      console.error(err);
      setIsListening(false);
      alert("Voice recognition failed. Try again!");
    };

    recognition.onend = () => {
      setIsListening(false); //  stop indicator
    };

    recognitionRef.current = recognition;
    recognition.start();
  };

  return { startListening, isListening };
};
